import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetCoreStylesMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setCoreStyles]: (localState: CoreState, coreStyles: Partial<CSSStyleDeclaration>) => {
      localState.coreStyles = coreStyles;
    }
  };
}
